import 'bootstrap/js/collapse';

import $ from 'jquery';
import _ from 'underscore';

import ActivityCollection from 'collections/activity';
import ChartDataCollection from 'collections/chart_data';
import ChartPoint from 'models/chart_point';
import Highcharts from 'highcharts/highcharts';
import YoursVsCommunityView from 'views/yours_vs_community';


export default YoursVsCommunityView.extend({
  initialize: function (options) {
    _.bindAll(this, 'show_loading', 'render');

    this.parent_view = options.parent_view;
    this.activity_log_collection = this.parent_view.activity_log_collection;
    this.activity_collection = this.parent_view.activity_collection;

    // This function belongs to the parent view
    this.setup_collapsers();

    // Chart elements
    this.your_popular_activities_el = $('#your-popular-activities', this.el);
    this.community_popular_activities_el = $('#community-popular-activities', this.el);
    this.charts = $(this.your_popular_activities_el).add(
      this.community_popular_activities_el);

    // store all the data needed for charting in a backbone collection
    this.chart_data = new ChartDataCollection();

    this.show_loading();

    $(window).resize(_.debounce(this.render, 1000));
  },

  show_loading: function () {
    if (!this.your_popular_activities_el.is('.default')) {
      /* global icon_loading_animation */
      this.charts.html('').css('background-image', 'url(' + icon_loading_animation + ')');
      this.charts.css('background-repeat', 'no-repeat');
      this.charts.css('background-position', 'center center');
    }
  },

  render: function () {
    this.show_loading();
    this.chart_data.reset();

    var self = this;

    // Yours data
    var yours_popular = new ActivityCollection(this.activity_collection.models, {
      comparator: ActivityCollection.user_favorites,
    });
    var community_activities = this.activity_collection.where({ is_custom: false });

    var top_community = Number(community_activities[0].get('num_activitylogs'));
    var top_yours = Number(yours_popular.at(0).get('num_user_activitylogs'));
    _.each([ 0, 1, 2, 3, 4 ], function (i) {
      var comm_act = community_activities[i];
      var yours_act = yours_popular.at(i);
      var comm_count = parseInt(comm_act.get('num_activitylogs'), 10);
      var comm_pct = comm_count / top_community * 100;
      var comm_name = comm_act.escape('name');
      var yours_count = parseInt(yours_act.get('num_user_activitylogs'), 10);
      var yours_pct = yours_count / top_yours * 100;
      var yours_name = yours_act.escape('name');
      var point = new ChartPoint();
      point.set({
        communities: { name: comm_name, y: comm_pct },
        yours: { name: yours_name, y: yours_pct }
      });
      self.chart_data.add(point);
    });

    // Create charts
    try {
      if (typeof this.your_chart !== 'undefined') {
        this.your_chart.destroy();
      }
    } catch (err) { /* Don't worry about it */ }
    try {
      if (typeof this.community_chart !== 'undefined') {
        this.community_chart.destroy();
      }
    } catch (err) { /* Don't worry about it */ }

    var chart_options = {
      chart: {
        backgroundColor: 'none',
        renderTo: this.your_popular_activities_el[0],
        borderWidth: 0,
        shadow: false,
        spacingLeft: 5,
        marginLeft: 7,
        reflow: false,
        type: 'bar',
        style: {
          fontFamily: "'proxima-nova', Helvetica, Arial, sans-serif"
        }
      },
      title: { text: '' },
      subtitle: { text: '' },
      legend: { enabled: false },
      tooltip: { enabled: false },
      plotOptions: {
        series: {
          dataLabels: {
            verticalAlign: 'middle',
            enabled: true,
            inside: false,
            x: 20,
            y: 0,
            style: {
              'fontFamily': "'proxima-nova', Helvetica, Arial, sans-serif",
              'fontSize': '16px',
              'float': 'right',
              'color': '#333333'
            },
            formatter: function () { return ''; }
          },
          borderColor: null,
          spacingTop: 10,
          shadow: false,
          borderRadius: 6,
          borderWidth: 0,
          pointWidth: 18,
        }
      },
      xAxis: {
        tickmarkPlacement: 'on',
        title: { text: '' },
        gridLineColor: '#c4c6be',
        gridLineWidth: 2,
        labels: {
          align: 'left',
          x: 10,
          y: -17,
          zIndex: 1000,
          useHTML: true,
          style: {
            fontFamily: "'proxima-nova', Helvetica, Arial, sans-serif",
            fontSize: '14px',
            fontWeight: 'bold',
            width: '300px',
            color: '#333333'
          },
        },
        type: 'category'
      },
      yAxis: {
        title: { text: '' },
        min: 0,
        max: 100,
        lineWidth: 0,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        lineColor: 'transparent',
        tickLength: 0,
        minorTickLength: 0,
        labels: { enabled: false }
      },
      series: [{
        name: 'For You',
        color: '#6bcadb',
        data: this.chart_data.pluck('yours')
      }],
      credits: {
        enabled: false
      }
    };

    if (!this.your_popular_activities_el.is('.default')) {
      this.your_chart = new Highcharts.Chart(chart_options);
    }

    // Adjust options for community chart
    chart_options.chart.renderTo = this.community_popular_activities_el[0];
    chart_options.series = [{
      name: 'Community',
      color: '#6bcadb',
      borderColor: '#6bcadb',
      data: this.chart_data.pluck('communities')
    }];
    this.community_popular_activities_el.css('display', 'block');
    this.community_chart = new Highcharts.Chart(chart_options);
    this.community_popular_activities_el.css('display', '');
    this.charts.css('background-image', 'none');

    for (var i = 0; i < $('.popular-x').length; i++) {
      $($('.popular-x')[i]).css({
        'width': this.$el.width() - 60 + 'px',
        'white-space': 'normal'
      });
      var newH = $($('.popular-x')[i]).height() + 5;
      $($('.popular-x')[i]).css('top', -newH);
    }

    this.popularResizeTO = null;
  }
});



// WEBPACK FOOTER //
// ./static/js/views/popular_activities_chart.js